<template>
</template>

<script>
import Vue from 'vue';
import * as api from '../scripts/services/api';

export default {
  data() {
    return {};
  },
  async mounted() {
    // Sunucuya haber ver: token'ı geçersiz kıl. Cookie'ler SONRA silinir, çünkü istek token'a ihtiyaç duyar.
    // Başarısız olursa (ağ yok, token zaten süresi geçmiş) yerel temizlik yine yapılmalı - aksi halde
    // kullanıcı çıkış yapamaz halde kalır. Sunucu tarafı iptal o durumda gerçekleşmez; bu bilinçli bir ödün.
    try {
      await api.logout();
    } catch (error) {
      console.error('Sunucu tarafında oturum kapatılamadı:', error);
    }

    this.$cookie.delete('token');
    this.$cookie.delete('tokenType');
    localStorage.removeItem('tokenExpireDate');
    localStorage.removeItem('menuItem');
    localStorage.removeItem('urlItem');
    localStorage.removeItem('serverSideItem');
    localStorage.removeItem('clientSideItem');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('eMail');
    localStorage.removeItem('company');
    window.location = '#/Login';
  },
};
</script>
